/*
import {
  hf,
  ht,
  cr,
  a,
  BoxC,
  GridC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as GridC from "./_cccGridC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';

import * as IcvI10a from './icvI10___Ti';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

            cr.c(IcvI10a.L, {
              key: -30,
              sPz: pz.sPz,
            }),

            cr.c(IcvI10a.B, {
              key: -40,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'gn7',
                onPrsBack: () => {
                  cr.moveTo({
                    pageName: 'icvHomeS40Rz',
                  });
                }
              }
            })

          ]
        })

      ]
    })
  );
};
